import React from "react"
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";
import {FilterExpander} from "../common/component/FilterExpander";
import StageFilterV2 from "./StageFilterV2"

const StageFilterV2Wrapper = () => {
    const {isMobile} = useDeviceLayout()

    return (
        <React.Fragment>
            {isMobile ?
                <FilterExpander>
                    <StageFilterV2 />
                </FilterExpander> :
                <StageFilterV2 />}
        </React.Fragment>
    )

}
export default StageFilterV2Wrapper


// WEBPACK FOOTER //
// ./src/components/stageStatus/StageFilterV2Wrapper.js